export const searchParamsBuilder = (params: Record<string, string> = {}) => {
    const search = new URLSearchParams(params);
    return search.toString();
};
